<template>
  <dr-wrapper v-if="!pageModel" v-bind="$props" v-on="wrapOn">
    <div :class="['dr-layout-placeholder', {'dr-layout-placeholder-main':isMainPlaceholder}]">
      <template>{{model.Name}}</template>
    </div>
  </dr-wrapper>

  <component v-else
    :class="{'dr-layout-placeholder-readonly': isInEditorMode}"
      :readonly='readonly'
      :is="currentPlaceholderModel.$Type"
      :model="currentPlaceholderModel"
      @modelChanged="$emit('modelChanged', currentPlaceholderModel)"
      @replaceComponent="onReplaceComponent"
      @close-dialog="$emit('close-dialog')"
  />
</template>

<script>
import baseMixin from '../../mixins/base-mixin'

export default {
  mixins: [baseMixin],

  beforeMount() {
    this.initializePlaceholderContent()
  },
  beforeUpdate() {
    this.initializePlaceholderContent()

  },
  computed: {
    isMainPlaceholder() {
      return this.model.Name == 'Main'
    },

    pageModel() {
      return this.$store.getters[`${this.stateName}/pageModel`]
    },
    currentPlaceholderModel() {
      return this.pageModel.LayoutCalls[this.model.Name]
    }
  },
  methods: {
    initializePlaceholderContent() {
      if (!this.pageModel || this.pageModel.LayoutCalls[this.model.Name] !== undefined) {
        return
      }
      this.$set(this.pageModel.LayoutCalls, this.model.Name,
        {
          $ID: `${this.model.Name}_simple_layout`,
          $Type: 'dr-simple-layout',
          Widgets: []
        })

    },
    onReplaceComponent({oldModel, newModel}) {
      if (this.currentPlaceholderModel !== oldModel) {
        return
      }
      this.$set(this.pageModel.LayoutCalls, this.model.Name, {
        $ID: `${this.model.Name}_simple_layout`,
        $Type: 'dr-simple-layout',
        Widgets: [newModel]
      })
      this.selectComponent(newModel)
      this.$emit('modelChanged', this.currentPlaceholderModel)
    }
  }

}
</script>

<style lang="scss">
.dr-layout-placeholder-readonly {
    background: #fff;
    position: relative !important;
    z-index: 1 !important;
}
.dr-layout-placeholder {
  border: 1px solid rgba(255, 0, 0, 0.836);
  background: rgba(255, 0, 0, 0.507);
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  &-main {
    background: rgba(255, 0, 0, 0.925);
  }
}
</style>
